var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HomeSection1'),_c('HomeMain'),_c('FloatDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }